// Phase 3 — Hyperlocal locality Home Tuition pages for Jabalpur / Bhopal / Nagpur.
// URL pattern: /home-tuition-{localitySlug}-{citySlug}
// e.g. /home-tuition-civil-lines-jabalpur, /home-tuition-mp-nagar-bhopal, /home-tuition-dharampeth-nagpur
//
// These are the ONLY geos where the phrase "Home Tuition" is legally used
// (offline in-home tutor visits). 10 top localities × 3 cities = 30 pages.
// Business rule: NEVER expand this table to non-offline cities.

export const OFFLINE_LOCALITY_CITIES = {
 jabalpur: {
 slug: "jabalpur",
 name: "Jabalpur",
 state: "Madhya Pradesh",
 countryCode: "IN",
 regionCode: "IN-MP",
 geo: { lat: 23.1815, lng: 79.9864 },
 phone: "our Jabalpur Head Office team",
 phoneRaw: "our Jabalpur Head Office team",
 boards: "CBSE, ICSE, MP Board, IGCSE, IB",
 schools: "DPS Jabalpur, Christ Church, St. Aloysius, KV NCC, Maharishi Vidya Mandir",
 exams: "NEET, JEE, MP-PET, RDVV",
 localColleges: "IIIT Jabalpur, JEC, GGITS, Hitkarini, MMMCH, RDVV",
 },
 bhopal: {
 slug: "bhopal",
 name: "Bhopal",
 state: "Madhya Pradesh",
 countryCode: "IN",
 regionCode: "IN-MP",
 geo: { lat: 23.2599, lng: 77.4126 },
 phone: "our Bhopal team",
 phoneRaw: "our Bhopal team",
 boards: "CBSE, ICSE, MP Board, IGCSE, IB",
 schools: "DPS Bhopal, Campion, Delhi Public School, Sagar Public, Jawahar Lal Nehru School",
 exams: "NEET, JEE, MP-PET, AIIMS Bhopal, NIT Bhopal",
 localColleges: "MANIT Bhopal, IISER, AIIMS Bhopal, IIIT-M Gwalior",
 },
 nagpur: {
 slug: "nagpur",
 name: "Nagpur",
 state: "Maharashtra",
 countryCode: "IN",
 regionCode: "IN-MH",
 geo: { lat: 21.1458, lng: 79.0882 },
 phone: "our Nagpur team",
 phoneRaw: "our Nagpur team",
 boards: "CBSE, ICSE, Maharashtra State Board (MSBSHSE), IGCSE, IB",
 schools: "CPS Nagpur, Bhavan's B P Vidya Mandir, Modern School, St. Vincent Pallotti, Centre Point",
 exams: "NEET, JEE, MHT-CET, GMC Nagpur",
 localColleges: "VNIT Nagpur, IIIT Nagpur, GHRCE, RCOEM, YCCE, GMC Nagpur",
 },
};

// 10 top localities per city — geo-weighted for highest search intent.
// Each locality includes a short local-flavour note used on the page.
export const OFFLINE_LOCALITIES = {
 jabalpur: [
 { slug: "vijay-nagar", name: "Vijay Nagar", note: "Jabalpur's flagship residential hub around Ghadi Chowk — where our Head Office is located since 2013. Home to premium schools (DPS Jabalpur, KV NCC) and the highest concentration of CBSE families." },
 { slug: "civil-lines", name: "Civil Lines", note: "Jabalpur's most upscale locality — Christ Church, St. Aloysius and heritage colonial bungalows. High-intent ICSE / ISC and IB families." },
 { slug: "wright-town", name: "Wright Town", note: "Central Jabalpur — walkable to Marhatal, Sadar and Vijay Nagar. Deep ICSE / CBSE overlap, active NEET / JEE tuition demand." },
 { slug: "napier-town", name: "Napier Town", note: "Old-town Jabalpur adjacent to Wright Town — dense Class 10-12 tutoring market, mostly MP Board & CBSE." },
 { slug: "adhartal", name: "Adhartal", note: "Fast-growing northern Jabalpur — KV Adhartal, DAV NCC, mostly CBSE. Vijay Nagar overflow." },
 { slug: "pachpedi", name: "Pachpedi", note: "Home to our second Jabalpur branch (Block D1 Aman Apartment) — near SP Bungalow, Dwarka Nagar Ward. Rapidly expanding CBSE demand." },
 { slug: "gwarighat", name: "Gwarighat", note: "Riverside Jabalpur near Narmada — home to our third branch (Forest Quarter). MP Board / CBSE mix with strong NEET-medical aspirant base." },
 { slug: "madan-mahal", name: "Madan Mahal", note: "Central Jabalpur transit hub — dense schools/coaching corridor. Every board taught here." },
 { slug: "ranjhi", name: "Ranjhi", note: "Southern Jabalpur — MP Board heavy with growing CBSE presence. Strong Class 10-12 board-exam tuition demand." },
 { slug: "garha", name: "Garha", note: "West Jabalpur — MP Board dominant, growing CBSE/ICSE. Anand Tutorials serves the entire Garha-Damoh Naka belt." },
 ],
 bhopal: [
 { slug: "mp-nagar", name: "MP Nagar", note: "Bhopal's coaching + tutoring capital — Zone I, II and III packed with families seeking 1:1 alternatives to batch coaching." },
 { slug: "arera-colony", name: "Arera Colony", note: "Bhopal's most upscale residential belt (E-Sectors, 10 No Market) — deep CBSE / ICSE / IB penetration." },
 { slug: "shahpura", name: "Shahpura", note: "Fast-growing New Bhopal — DPS Bhopal, Sagar Public, Delhi Public School. High CBSE / IB demand." },
 { slug: "kolar-road", name: "Kolar Road", note: "New Bhopal southern corridor — Salaiya, Nayapura. Rapidly growing CBSE base, strong NEET / JEE aspirant density." },
 { slug: "habibganj", name: "Habibganj", note: "Central Bhopal near Habibganj station — mixed ICSE / CBSE, strong Class 10-12 board tuition market." },
 { slug: "bairagarh", name: "Bairagarh", note: "Old Bhopal (Sant Hirdaram Nagar) — CBSE / MP Board mix, growing NEET-medical aspirant base." },
 { slug: "bhel", name: "BHEL", note: "BHEL Township (Piplani, Habibganj) — CBSE-heavy engineering-family belt, strong JEE prep demand." },
 { slug: "tt-nagar", name: "TT Nagar", note: "Old Bhopal residential/government belt — mixed CBSE + MP Board, near South T.T. Nagar (Aradhana Nagar, Dr. Ambedkar Nagar) where our Bhopal branch operates." },
 { slug: "misrod", name: "Misrod", note: "Southern Bhopal — new IT / residential belt, mostly CBSE, growing JEE / NEET prep base." },
 { slug: "hoshangabad-road", name: "Hoshangabad Road", note: "South Bhopal expressway corridor — Ayodhya Bypass, mixed CBSE / MP Board, strong Class 10-12 board demand." },
 ],
 nagpur: [
 { slug: "dharampeth", name: "Dharampeth", note: "Nagpur's most upscale residential locality — CPS Nagpur, Bhavan's, St. Vincent Pallotti. Deep ICSE / ISC and CBSE overlap." },
 { slug: "civil-lines", name: "Civil Lines", note: "Colonial-era Nagpur heart — heritage schools, mixed ICSE / CBSE demand, high board tuition intensity." },
 { slug: "ramdaspeth", name: "Ramdaspeth", note: "Central Nagpur — schools + medical belt, strong NEET aspirant density, mostly CBSE / ICSE." },
 { slug: "wardha-road", name: "Wardha Road", note: "South Nagpur expressway corridor — Somalwar Nikalas, Modern School. Fast-growing CBSE / IB demand." },
 { slug: "manish-nagar", name: "Manish Nagar", note: "East Nagpur residential — mixed CBSE + Maharashtra State Board, strong Class 10-12 demand." },
 { slug: "sadar", name: "Sadar", note: "Cantonment-adjacent Nagpur — Bhavan's B P Vidya Mandir, Centre Point School. Strong ICSE / CBSE overlap." },
 { slug: "khamla", name: "Khamla", note: "West Nagpur — CBSE heavy, growing NEET / MHT-CET aspirant base." },
 { slug: "pratap-nagar", name: "Pratap Nagar", note: "Central Nagpur — mixed CBSE + State Board, deep board-exam tuition demand for Class 10-12." },
 { slug: "bajaj-nagar", name: "Bajaj Nagar", note: "Central Nagpur near VNIT — engineering-family belt, strong JEE / GATE preparation demand." },
 { slug: "dhantoli", name: "Dhantoli", note: "Central Nagpur — heritage residential + hospitals, strong Class 10-12 board-tuition market with heavy NEET-medical density." },
 ],
};

// Helper: fully-resolved locality page data — used by HomeTuitionLocality.jsx
export function getOfflineLocalityData(localitySlug, citySlug) {
 const city = OFFLINE_LOCALITY_CITIES[citySlug];
 if (!city) return null;
 const localities = OFFLINE_LOCALITIES[citySlug] || [];
 const locality = localities.find((l) => l.slug === localitySlug);
 if (!locality) return null;

 const path = `/home-tuition-${localitySlug}-${citySlug}`;
 const canonical = `https://anandtutorials.com${path}`;

 const h1 = `Home Tuition in ${locality.name}, ${city.name} — 1:1 Verified Home Tutors`;
 const seoTitle = `Home Tuition in ${locality.name}, ${city.name} | Verified 1:1 Home Tutors | Anand Tutorials`;
 const seoDescription = `Best home tuition in ${locality.name}, ${city.name}. Verified 1:1 home tutors visit your address in ${locality.name} — CBSE, ICSE, ${city.boards.split(",").slice(2, 3)[0] || "State Board"}, NEET, JEE. Free demo. Call ${city.phone}.`;
 const keywords = [
 `home tuition in ${locality.name}`,
 `home tuition ${locality.name} ${city.name}`,
 `home tutor ${locality.name}`,
 `home tutor in ${locality.name} ${city.name}`,
 `best home tutor ${locality.name}`,
 `CBSE tutor ${locality.name}`,
 `ICSE tutor ${locality.name}`,
 `NEET coaching ${locality.name}`,
 `JEE coaching ${locality.name}`,
 `private tutor ${locality.name} ${city.name}`,
 `Anand Tutorials ${locality.name}`,
 `1:1 home tuition ${locality.name}`,
 `female home tutor ${locality.name}`,
 ].join(", ");

 return {
 path, canonical, city, locality,
 h1, seoTitle, seoDescription, keywords,
 intro: `Anand Tutorials sends verified 1:1 home tutors to your address in ${locality.name}, ${city.name}. ${locality.note} With 12+ years of ${city.name} experience, 8,000+ students taught locally and a verified tutor pool drawn from ${city.localColleges}, we match your child to the right ${locality.name} home tutor within 24-48 hours — for CBSE, ICSE, ${city.boards.split(",").slice(2).join(",").trim() || "State Board"}, NEET, JEE and every school subject.`,
 eyebrow: `Home Tuition · ${locality.name} · ${city.name}`,
 whySections: [
 {
 h2: `Home tuition in ${locality.name} — hyperlocal advantage`,
 p: `Our ${city.name} tutor network dispatches specifically to ${locality.name} and nearby localities. Tutors know the local schools (${city.schools}), pace of the ${city.name} academic calendar, and the specific pattern of ${city.boards}. No generalist tutors sent from 15 km away — every ${locality.name} household gets a tutor who lives or teaches in the same belt.`,
 },
 {
 h2: `Every board covered — CBSE, ICSE, ${city.boards.split(",").slice(2, 3)[0]?.trim() || "State Board"}, IB / IGCSE`,
 p: `We tutor every board taught in ${locality.name}: ${city.boards}. Subject-specialist tutors for Mathematics, Physics, Chemistry, Biology, English, Hindi, Sanskrit, Social Studies, Computer Science, Accountancy, Business Studies, Economics. Class 1-12 fully covered.`,
 },
 {
 h2: `${locality.name} NEET & JEE coaching — 1:1, never batch`,
 p: `Coaching centres in ${city.name} run 80-120 student batches. We don't. Every ${locality.name} student is matched to a 1:1 mentor — often ${city.localColleges} or AIIMS / IIT alumni — with chapter mocks, weekly full-length tests and direct doubt-clearing on WhatsApp. If your child is targeting ${city.exams}, we deliver 1:1 preparation that actually works.`,
 },
 {
 h2: `Free 1:1 home tuition demo — ${locality.name}, ${city.name}`,
 p: `Every ${locality.name} family gets a 100% free 1:1 demo class before any payment. The tutor visits your address in ${locality.name} (or joins live online) at your preferred slot. Parents may attend. You only pay if you decide to continue. Call our ${city.name} coordinator at ${city.phone} — most demos are scheduled within 24-48 hours.`,
 },
 ],
 faqs: [
 [`Do you provide home tuition in ${locality.name}?`,
 `Yes — verified 1:1 home tutors reach every household in ${locality.name}, ${city.name} within 24-48 hours of booking. Anand Tutorials operates in-home visits in Jabalpur, Bhopal and Nagpur (the only offline cities) — ${city.name} is one of our flagship offline branches.`],
 [`Which boards do you cover for ${locality.name} students?`,
 `Every board taught in ${city.name}: ${city.boards}. Subject-specialist tutors match your child's specific board and school pattern.`],
 [`Are NEET / JEE mentors available in ${locality.name}?`,
 `Yes — 1:1 NEET / JEE / ${city.exams.split(",").slice(2, 3)[0]?.trim() || "State entrance"} mentors, many of whom are AIIMS, IIT and ${city.localColleges.split(",")[0].trim()} alumni. Never a batch.`],
 [`How much does home tuition cost in ${locality.name}?`,
 `Fees depend on grade, subject and frequency. We share a transparent monthly quote at the free demo. No hidden charges, no lock-in — cancel anytime.`],
 [`Are female home tutors available in ${locality.name}?`,
 `Yes — verified female home tutors available for ${locality.name} households on request. No extra charge.`],
 [`Is the demo class really free in ${locality.name}?`,
 `100% free. Tutor visits your ${locality.name} home (or joins live online) at your preferred slot. Parents may attend the full demo. No payment required to schedule.`],
 [`Can I switch between home tutor and online classes?`,
 `Absolutely. Same tutor, same plan — switch the format anytime, no extra cost. Many ${locality.name} families alternate based on weather, exams or schedule.`],
 ],
 };
}

// Emit all 30 locality paths (sitemap + route generation)
export function getAllOfflineLocalityPaths() {
 const paths = [];
 for (const citySlug of Object.keys(OFFLINE_LOCALITIES)) {
 for (const loc of OFFLINE_LOCALITIES[citySlug]) {
 paths.push(`/home-tuition-${loc.slug}-${citySlug}`);
 }
 }
 return paths;
}
